// Common
export const ResourcePrice = () => import("./common/ResourcePrice.vue");
export const SidebarService = () => import("./common/SidebarService.vue");
export const ManualDocument = () => import("./common/ManualDocument.vue");
export const CardTable = () => import("./common/card-table/CardTable.vue");
export const TableSetting = () =>
  import("./common/card-table/TableSetting.vue");
export const BoxDocument = () => import("./common/BoxDocument.vue");
export const CardDelete = () => import("./common/CardDelete.vue");
export const BorderTab = () => import("./common/BorderTab.vue");

// Dialog
export const ConfirmDeleteDialog = () =>
  import("./dialog/ConfirmDeleteDialog.vue");
export const ConfirmDialog = () => import("./dialog/ConfirmDialog.vue");
export const PermissionDialog = () => import("./dialog/PermissionDialog.vue");
export const ConfirmValidateDialog = () =>
  import("./dialog/ConfirmValidateDialog.vue");

// Scope Dialog
export const ScopeDialog = () => import("./dialog/ScopeDialog.vue");

// Suggestion
export const SuggestionDialogV4 = () =>
  import("./suggestion/v4/SuggestionV4.vue");
export const CollapseResource = () =>
  import("./suggestion/v4/CollapseResource.vue");
// Chuẩn bị xóa trong phiên bản tiếp theo
export const SuggestionDialog = () => import("./suggestion/v3/Suggestion.vue");

// Alert
export const BoxAlert = () => import("./alert/BoxAlert.vue");
export const VerifyAccountAlert = () =>
  import("./alert/VerifyAccountAlert.vue");

// Error Page
export const DynamicError = () => import("./error-page/DynamicError.vue");
export const PageNotFound = () => import("./error-page/PageNotFound.vue");

// Prebuild App
export const PrebuildApp = () => import("./prebuild-app/PrebuildApp.vue");

// Os
export const TabsOs = () => import("./os/TabsOs.vue");
export const OsDropBox = () => import("./os/box/OsDropBox.vue");
export const CreateLink = () => import("./os/CreateLink.vue");
export const OsList = () => import("./os/list/OsList.vue");
export const AppList = () => import("./os/list/AppList.vue");

// Server
export const ServerType = () => import("./server/ServerType.vue");

// Flavor
export const SelectFlavor = () => import("./flavor/SelectFlavor.vue");
export const ConfigParams = () => import("./flavor/ConfigParams.vue");
export const ConfigParamsIC = () => import("./flavor/ConfigParamsIC.vue");
export const BoxFlavor = () => import("./flavor/box/BoxFlavor.vue");

// Region
export const SelectRegion = () => import("./region/SelectRegion.vue");
export const ListRegions = () => import("./region/ListRegions.vue");

// SSH Key
export const Accuracy = () => import("./ssh-key/Accuracy.vue");
export const CreateSshKey = () => import("./ssh-key/CreateSshKey.vue");
export const UserData = () => import("./ssh-key/UserData.vue");

// Volume
export const AddVolume = () => import("./volume/AddVolume.vue");
export const ConfigOptions = () => import("./volume/ConfigOptions.vue");

// Network
export const PlanNetwork = () => import("./network/PlanNetwork.vue");

// Certificate
export const CertificateCrafting = () =>
  import("./certification/CertificateCrafting.vue");
export const CreateCertification = () =>
  import("./certification/CreateCertification.vue");

// Rule Engine
export const DefaultAction = () =>
  import("./rule-engine/default/DefaultAction.vue");
export const CustomRule = () => import("./rule-engine/custom/CustomRule.vue");

// Domain Verify
export const DomainVerify = () => import("./domain-verify/DomainVerify.vue");

// Billing
export const ListPlan = () => import("./billing/ListPlan.vue");
export const SelectPlan = () => import("./billing/SelectPlan.vue");

// Chart
export const BarChart = () => import("./chart/BarChart.vue");
export const DoughnutChart = () => import("./chart/DoughnutChart.vue");
export const HorizontalBarChart = () =>
  import("./chart/HorizontalBarChart.vue");
export const LineChart = () => import("./chart/LineChart.vue");
export const PieChart = () => import("./chart/PieChart.vue");

// Custom Form
export const OtpInput = () => import("./custom-form/OtpInput.vue");

// Verify Account
export const VerifyAccount = () => import("./error-page/VerifyAccount.vue");

// config dns table
export const ConfigDnsTable = () => import("./config-dns/ConfigDnsTable.vue");

// quota info dialog
export const QuotaInfo = () => import("./quotas/QuotaInfo.vue");

export const CouponBanner = () => import("./coupon/CouponBanner.vue");
